<template>
  <v-card>
     <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        class='font-weight-light'
        v-model="search"
        append-icon="mdi-magnify"
        label="Search adoption profile"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :loading='loading'
      :headers='headers'
      :items='adoptionProfile'
      :search='search'
      class='elevation-1'
    >
    <template v-slot:top>
        <v-toolbar flat id='manageTable'>
          <v-toolbar-title class='display-1 fontcolor'>{{TABLE_TITLE}}</v-toolbar-title>
          <v-spacer></v-spacer>
         <v-dialog default v-model='dialog' max-width='500px' scrollable>
            <template v-slot:activator='{ on }'>
              <v-btn outlined dark class='mb-2 fontcolor' v-on='on'  @click="hideEditedFields">
                <v-icon dark>mdi-plus</v-icon>
                {{ ADD_NEW_ADOPTION_PROFILE }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class='headline fontcolor'>{{ formTitle }}</span>
              </v-card-title>
              <v-card class="pl-7 pr-6 pt-5 pb-5" >
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model='editedItem.name'
                        hint='Please enter adoption profile'
                        label='Adoption Profile*'
                        :rules="adopProValidationRules"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="editedFields" >
                      <v-select
                        v-model='editedItem.status'
                        :items="statusItems"
                        label="Status*"
                        :rules="statusValidationRules"
                        item-text="statusText"
                        item-value="statusVal"
                      ></v-select>
                    </v-col>
                    <v-col v-else >
                      <v-select
                        v-model='defaultStatus'
                        :items="defaultStatusItems"
                        label="Status*"
                        :rules="statusValidationRules"
                        id="statusFieldId"
                      ></v-select>
                    </v-col>
                  </v-row>
                   <!-- Below fields will view only on edit county form.
                      All below fields will be in disable mode.
                   -->
                  <v-row v-if="editedFields">
                  <v-col>
                      <v-text-field disabled v-model='editedItem.createdBy'
                      label='Created By'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.createdDate'
                      label='Created On'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields && (editedItem.createdDate !== editedItem.modifiedDate)">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.modifiedBy'
                      label='Modified By'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields && (editedItem.createdDate !== editedItem.modifiedDate)">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.modifiedDate'
                      label='Modified On'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <small color="primary">*indicates required fields</small>
                    <v-spacer></v-spacer>
                    <v-btn outlined dark color='red' @click='closeDialogFrm'>
                      <v-icon dark>mdi-close</v-icon>Cancel
                    </v-btn>
                    <v-btn :loading='btnLoader' outlined class='fontcolor' :disabled="!valid" @click='save'>
                      <v-icon dark>mdi-check</v-icon>Save
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action='{ item }'>
        <v-icon text small class='mr-2' @click='editItem(item)'>mdi-border-color</v-icon>
      </template>
       <template v-slot:no-data>
        <p>{{NO_DATA_FOUND}}</p>
      </template>
    </v-data-table>
    </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  data: () => ({
    loading: true,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    TABLE_TITLE: CONSTANTS.MANAGE_ADOPTION_PROFILE,
    ADD_NEW_ADOPTION_PROFILE: CONSTANTS.ADD_NEW_ADOPTION_PROFILE,
    search: '',
    dialog: false,
    editedIndex: -1,
    edited: false,
    status: '',
    btnLoader: false,
    valid: true,
    adopProValidationRules: [
      v => !!v || 'Adoption Profile is required.',
      v => /^[a-zA-Z .]+$/.test(v) || 'Invalid input. Only characters (A-Z, a-z), space, period is allowed!',
      v => /^[a-zA-Z .]{1,255}$/.test(v) || 'Invalid input. Maximum length 255 characters!'
    ],
    statusValidationRules: [
      v => !!v || 'Status is required.'
    ],
    defaultStatus: CONSTANTS.DEFAULT_RECORDS_STATUS,
    statusValues: CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE,
    defaultStatusItems: CONSTANTS.RECORDS_STATUS,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    // table headers
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'id',
        class: 'title'
      },
      {
        text: 'Adoption Profile',
        value: 'name',
        sortable: true,
        class: 'title'
      },
      {
        text: 'Status',
        value: 'statusText',
        sortable: false,
        class: 'title'
      },
      { text: 'Actions', value: 'action', sortable: false, class: 'title' }
    ],
    editedItem: {
      name: '',
      status: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: ''
    }
  }),
  computed: {
    // to fetch Adoption Profile list
    adoptionProfile () {
      return this.$store.getters['AdoptionProfileModule/fetchAdoptionProfileList']
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Add New Adoption Profile' : 'Edit Adoption Profile'
    },
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    editedFields () {
      return this.edited
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    // dispatch an action in below method to fetch Adoption Profile list
    initialize () {
      new Promise((resolve, reject) => {
        let status = '' // by default it will display all list records, declared 'status' here for future use
        this.$store.dispatch('AdoptionProfileModule/getAdoptionProfileList', { resolve, reject, status })
      }).then((responseData) => {
        this.loading = false
      }).catch(({ response }) => {
        this.loading = false
      })
    },
    hideEditedFields () {
      this.edited = false
    },
    editItem (selectedRecord) {
      this.editedIndex = this.adoptionProfile.indexOf(selectedRecord)
      this.editedItem = Object.assign({}, selectedRecord)
      this.dialog = true
      this.edited = true
    },
    closeDialogFrm () {
      this.editedItem = Object.assign({}, {})
      this.editedIndex = -1
      this.editedItem.name = ''
      this.editedItem.status = CONSTANTS.DEFAULT_RECORDS_STATUS
      this.defaultStatus = CONSTANTS.DEFAULT_RECORDS_STATUS
      this.$refs.form.resetValidation()
      this.dialog = false
    },
    save () {
      if (this.editedIndex > -1 && this.$refs.form.validate()) {
        this.btnLoader = true
        Object.assign(this.editedItem)
        let editYearData = this.editedItem
        const editedData = {
          name: editYearData.name,
          status: editYearData.status,
          userId: this.userId,
          id: Number(editYearData.id)
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionProfileModule/editAdoptionProfileItem', { resolve, reject, editedData })
        }).then((responseData) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = responseData.responseMessage
          this.$globalStates.notification.init_notifications = true
          this.closeDialogFrm()
        }).catch((response) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
      } else {
        if (this.$refs.form.validate()) {
          let statusField = 1
          if (this.defaultStatus === 'Inactive') {
            statusField = this.statusValues.Inactive
          } else if (this.defaultStatus === 'Published') {
            statusField = this.statusValues.Published
          }
          this.btnLoader = true
          const formData = {
            name: this.editedItem.name,
            status: statusField,
            userId: this.userId
          }
          new Promise((resolve, reject) => {
            this.$store.dispatch('AdoptionProfileModule/addAdoptionProfileItem', { resolve, reject, formData })
          }).then((responseData) => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = responseData.responseMessage
            this.$globalStates.notification.init_notifications = true
            this.closeDialogFrm()
          }).catch((response) => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = response.responseMessage
            this.$globalStates.notification.init_notifications = true
          })
        }
      }
    }
  }
}
</script>
